import { Letter } from 'state/letter/types'
import { useDownloadLetterMutation } from 'state/letter/api'

import { CellProps, Icon } from 'components/ui'

import { Wrapper, Title, Value, DownloadButton } from '../Style'

export function Link({ row }: CellProps<Letter>) {
  const { link, id } = row.original
  const [downloadLetter, { isLoading }] = useDownloadLetterMutation()

  if (!link) {
    return (
      <Wrapper area='Link'>
        <Title>Link</Title>
        <Value>-</Value>
      </Wrapper>
    )
  }

  return (
    <Wrapper area='Link'>
      <Title>Link</Title>
      <Value>
        <DownloadButton onClick={() => downloadLetter({ id })} disabled={isLoading}>
          <Icon name='download' size='medium' />
        </DownloadButton>
      </Value>
    </Wrapper>
  )
}
